// Analytics tracking utility

const SESSION_KEY = 'sm_session_id';

function getSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export async function trackPageView(path?: string): Promise<void> {
  try {
    const currentPath = path || window.location.pathname;
    const referrer = document.referrer || undefined;
    const sessionId = getSessionId();
    
    // Get auth token if available
    const token = localStorage.getItem('accessToken');
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    await fetch('/api/analytics/page-view', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        path: currentPath,
        referrer,
        sessionId,
      }),
    });
  } catch (error) {
    // Silently fail - don't break the app for analytics
    console.debug('Analytics tracking failed:', error);
  }
}

// Track on initial load and route changes
let lastPath = '';

export function initAnalytics(): void {
  // Track initial page view
  trackPageView();
  lastPath = window.location.pathname;
  
  // Listen for route changes (for SPAs)
  const originalPushState = history.pushState;
  history.pushState = function(...args) {
    originalPushState.apply(this, args);
    const newPath = window.location.pathname;
    if (newPath !== lastPath) {
      lastPath = newPath;
      trackPageView(newPath);
    }
  };
  
  // Also handle popstate (back/forward)
  window.addEventListener('popstate', () => {
    const newPath = window.location.pathname;
    if (newPath !== lastPath) {
      lastPath = newPath;
      trackPageView(newPath);
    }
  });
}
